import { Sparkles } from 'lucide-react';

import type { VenueCreateForm } from './useVenueCreateForm';

/** Offers to pull the venue's address from its website. */
export function EnrichmentCard({ form }: { form: VenueCreateForm }) {
  const { enrich, fields, pull } = form;
  const message =
    enrich === 'done'
      ? `The address fields pre-filled from ${fields.domain}.`
      : enrich === 'fetching'
        ? 'Reading their site…'
        : enrich === 'failed'
          ? "Couldn't read the site automatically — fill in the address manually."
          : 'Pull the address from their site — the next step fills itself.';
  return (
    <div
      style={{
        border: '1px dashed var(--nb-border-2)',
        borderRadius: 10,
        padding: '12px 14px',
        background: enrich === 'done' ? 'var(--nb-primary-soft)' : 'var(--nb-surface)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <span style={{ flex: 1, fontSize: 11, color: 'var(--nb-muted)', lineHeight: 1.45 }}>
        {enrich === 'done' ? (
          <strong style={{ color: 'var(--nb-primary)' }}>{message}</strong>
        ) : (
          message
        )}
      </span>
      {enrich !== 'done' && (
        <button
          type="button"
          onClick={pull}
          disabled={enrich === 'fetching' || !fields.domain.trim()}
          className="nb-cdrawer-btn nb-cdrawer-btn--primary"
          style={{ whiteSpace: 'nowrap', opacity: fields.domain.trim() ? 1 : 0.5 }}
        >
          <Sparkles size={13} style={{ marginRight: 5, verticalAlign: '-2px' }} />
          {enrich === 'fetching' ? 'Pulling…' : 'Pull venue info'}
        </button>
      )}
    </div>
  );
}
